import ServerSSRTranslatedInterface from '../../interfaces/server/SSRTranslated'

export const name = (ssr: ServerSSRTranslatedInterface) => ssr.Label || ssr.id

export const isAddedByTourOperator = (ssr: ServerSSRTranslatedInterface) =>
  Boolean(ssr.isAddedByTourOperator)

export const isSpecialSSR = (ssr: ServerSSRTranslatedInterface) =>
  Boolean(ssr.isSpecialSSR)

export default {
  id: 'id',
  name,
  isAddedByTourOperator,
  isSpecialSSR,
  ssrNumber: 'ssrNumber',
  isLimited: 'isLimited',
  availableCount: 'availableCount',
}
